// extracted by css-extract-rspack-plugin
export default {"disabled":"InternalLink_disabled__COt6K"};